import React from 'react';
import PropTypes from 'prop-types';

const propTypes = {
  color: PropTypes.string,
  size: PropTypes.number,
};

const IntroSlideIcon = ({ color = '#1A2E34', size = 24, ...props }) => (
  <svg
    viewBox="0 0 48 48"
    width={size}
    height={size}
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M41.295 0A6.713 6.713 0 0 1 48 6.705v34.59A6.713 6.713 0 0 1 41.295 48H6.705A6.713 6.713 0 0 1 0 41.295V6.705A6.713 6.713 0 0 1 6.705 0zm3.627 42H3.072a3.706 3.706 0 0 0 3.633 3h34.59a3.707 3.707 0 0 0 3.627-3zM45 9H3v30h42V9zm-21.002 4.509c1.184 0 2.266.672 2.79 1.734l1.676 3.394 3.75.545a3.088 3.088 0 0 1 2.511 2.118 3.093 3.093 0 0 1-.786 3.183l-2.712 2.643.64 3.732a3.112 3.112 0 0 1-4.516 3.28L24 32.379l-3.354 1.76a3.108 3.108 0 0 1-4.517-3.28l.641-3.732-2.712-2.643a3.114 3.114 0 0 1 1.725-5.309l3.75-.544 1.674-3.387a3.113 3.113 0 0 1 2.79-1.734zM24 16.5l-2.125 4.164a1.5 1.5 0 0 1-1.128.822l-4.529.659-.061.19 3.283 3.201a1.5 1.5 0 0 1 .43 1.327l-.772 4.51.162.118 4.05-2.128a1.5 1.5 0 0 1 1.395 0l4.05 2.128 1.641-.372-1.479.253-.773-4.509a1.5 1.5 0 0 1 .431-1.327l3.268-3.201-.061-.19-4.529-.659a1.5 1.5 0 0 1-1.128-.822l-2.024-4.101A.095.095 0 0 0 24 16.5zM41.295 3H6.705a3.707 3.707 0 0 0-3.633 3h41.856a3.706 3.706 0 0 0-3.633-3z"
      fill={color}
      fillRule="nonzero"
    />
  </svg>
);

IntroSlideIcon.propTypes = propTypes;

export default IntroSlideIcon;
